import { endorsementList } from '../request';
import { downloadFileByUrl } from '@/utils/public.js';
export default {
  props: {
    batchListVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const that = this;
    return {
      columns: [{
        slots: {
          title: '文件名'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '增减员时间范围'
        },
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'customTimeRange'
        }
      }, {
        slots: {
          title: '批单生成日期'
        },
        dataIndex: 'generationDate',
        key: 'generationDate',
        align: 'center'
      }, {
        slots: {
          title: '批单文件'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 250,
        key: '9'
      }],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSizeOptions: ['3', '10', '20', '50', '100'],
        pageSize: 3,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      }
    };
  },
  watch: {
    batchListVisible(newVal) {
      if (newVal) {
        this.pagination.current = 1;
        this.pagination.pageSize = 3;
        this.getList();
      }
    }
  },
  methods: {
    getList() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      endorsementList(params).then(res => {
        if (res && res.items) {
          this.data = res.items;
          this.pagination.total = res.totalNum;
        }
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getList();
    },
    download(record) {
      if (record.url) {
        downloadFileByUrl(record.url);
      }
    }
  }
};